import Trajet from '@amo/core/assets/images/AMO_Icons/Trajet.svg';
import info from '@amo/core/assets/images/icons/info.svg';
import { BulleAide, Question } from '@amo/core/components/containers';
import { Radio } from '@amo/core/components/forms';
import _ from 'lodash';
import { Field } from 'redux-form';
import Swal from 'sweetalert2';

export const AssuranceTransitoire = (props) => {
    const { nextQuestion, data, apporteur1, changeValue, source, formInitialValues } = props;

    const OPTIONS = {
        ALREADY_SOLD: 'already_sold',
        KEEP_INSURANCE: 'keep_insurance',
        SELL_LATER: 'sell_later',
        SELLING_NOW: 'selling_now'
    };

    const newVehicleType = _.get(data, 'typeVehicule');
    const oldVehicleType = _.get(formInitialValues, 'typeVehicule');

    const getDisplayOptions = () => {
        if (apporteur1.codeBelair === 43397 && oldVehicleType === 'moto' && newVehicleType === 'moto') {
            return {
                [OPTIONS.ALREADY_SOLD]: true,
                [OPTIONS.KEEP_INSURANCE]: true,
                [OPTIONS.SELL_LATER]: true,
                [OPTIONS.SELLING_NOW]: true
            };
        } else if (apporteur1.codeBelair !== 43397 && oldVehicleType === 'moto' && newVehicleType === 'moto' && source == 'conseiller') {
            return {
                [OPTIONS.ALREADY_SOLD]: true,
                [OPTIONS.KEEP_INSURANCE]: true,
                [OPTIONS.SELL_LATER]: true,
                [OPTIONS.SELLING_NOW]: false
            };
        }
        return {
            [OPTIONS.ALREADY_SOLD]: true,
            [OPTIONS.KEEP_INSURANCE]: false,
            [OPTIONS.SELL_LATER]: false,
            [OPTIONS.SELLING_NOW]: true
        };
    };

    const displayOptions = getDisplayOptions();

    const handleOptionClick = (optionValue, showPopup = false) => {
        changeValue('DemandeTarif[Vehicule][AssuranceTransitoireValue]', optionValue);

        if (showPopup) {
            if (source === 'site') {
                Swal.fire({
                    icon: 'info',
                    title: 'Vous avez acheté un nouveau 2-roues ?',
                    text: 'Vous êtes actuellement sur le formulaire d\'avenant permettant de modifier le contrat de votre véhicule actuel. Pour assurer un véhicule supplémentaire, cliquez sur "Réalisez un nouveau devis" depuis la page d\'accueil de l\'espace client.',
                    showConfirmButton: true,
                    confirmButtonText: 'C\'est parti',
                    showCloseButton: true,
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.href = 'https://mon-espace.april-moto.com/';
                    }
                });
            } else {
                Swal.fire({
                    icon: 'warning',
                    iconHtml: '<span class="warning"></span>',
                    title: 'Transfert à la cellule Fidélisation',
                    text: 'Veuillez transférer l\'assuré / courtier à la cellule Fidélisation. Si pas disponible, faire un agenda FID ou transferér l\'appel à ADM',
                    showConfirmButton: true,
                    confirmButtonText: 'Ok',
                    showCloseButton: true,
                });
            }
        } else if (optionValue === OPTIONS.SELLING_NOW && source === 'conseiller') {
            Swal.fire({
                icon: 'info',
                title: 'Assuré éligible à l\'assurance transitoire',
                html: `
                    <p>Veuillez informer l'assuré qu'il peut bénéficier de l'assurance transitoire une fois qu'il aura signé son avenant de changement de véhicule. En quoi ça consiste :</p>
                    <ul style="text-align: left; margin-top: 10px;">
                        <li>Son ancien véhicule reste assuré pendant 30 jours avec les mêmes garanties et options que celles du nouveau véhicule</li>
                        <li>Uniquement si l'ancien véhicule est mis en circulation pour des essais en vue de la vente</li>
                    </ul>
                `,
                showConfirmButton: true,
                confirmButtonText: 'Continuer',
                showCloseButton: true,
            });
        }
    };

    const handleContinue = () => {
        const selectedOption = _.get(data, 'DemandeTarif[Vehicule][AssuranceTransitoireValue]');
        if (selectedOption) {
            const booleanValue = selectedOption === OPTIONS.SELLING_NOW;
            changeValue('DemandeTarif[Vehicule][AssuranceTransitoire]', booleanValue);
            nextQuestion(300);
        }
    };

    const isButtonDisabled = () => {
        const selectedOption = _.get(data, 'DemandeTarif[Vehicule][AssuranceTransitoireValue]');
        return !selectedOption || selectedOption === OPTIONS.KEEP_INSURANCE || selectedOption === OPTIONS.SELL_LATER;
    };

    return (
        <Question
            icon={Trajet}
            title={'Que faites-vous de <strong>votre <br/>véhicule actuel ?</strong>'}
        >
            <BulleAide
                icon={info}
                title={`<b>Rappel obligatoire d'assurance</b>`}
                text={`<p>Conformement à l'article L211-1 du Code des assurances, votre véhicule doit être couvert par un contrat d'assurance (à minima avec la garantie responsabilité civile)</b>`}
                className={'col-lg-12 col-md-12 f-14 mt-5'}
            />

            <div className={'row justify-content-center '}>
                {displayOptions[OPTIONS.ALREADY_SOLD] && (
                    <div className={'col-lg-4 col-md-6 col-sm-6 col-6 my-2'}>
                        <Field
                            component={Radio}
                            type={'radio'}
                            name={'DemandeTarif[Vehicule][AssuranceTransitoireValue]'}
                            value={OPTIONS.ALREADY_SOLD}
                            label={'Je l\'ai déjà vendu / Reprise du véhicule par le concessionnaire'}
                            onClick={() => handleOptionClick(OPTIONS.ALREADY_SOLD)}
                        />
                    </div>
                )}

                {displayOptions[OPTIONS.KEEP_INSURANCE] && (
                    <div className={'col-lg-4 col-md-6 col-sm-6 col-6 my-2'}>
                        <Field
                            component={Radio}
                            type={'radio'}
                            name={'DemandeTarif[Vehicule][AssuranceTransitoireValue]'}
                            value={OPTIONS.KEEP_INSURANCE}
                            label={'Je souhaite <strong>garder</strong> l\'assurance de mon véhicule actuel ET assurer un <strong>véhicule supplémentaire</strong>'}
                            onClick={() => handleOptionClick(OPTIONS.KEEP_INSURANCE, true)}
                        />
                    </div>
                )}

                {displayOptions[OPTIONS.SELL_LATER] && (
                    <div className={'col-lg-4 col-md-6 col-sm-6 col-6 my-2'}>
                        <Field
                            component={Radio}
                            type={'radio'}
                            name={'DemandeTarif[Vehicule][AssuranceTransitoireValue]'}
                            value={OPTIONS.SELL_LATER}
                            label={'Je le vendrais <strong>plus tard</strong>'}
                            onClick={() => handleOptionClick(OPTIONS.SELL_LATER, true)}
                        />
                    </div>
                )}

                {displayOptions[OPTIONS.SELLING_NOW] && (
                    <div className={'col-lg-4 col-md-6 col-sm-6 col-6 my-2'}>
                        <Field
                            component={Radio}
                            type={'radio'}
                            name={'DemandeTarif[Vehicule][AssuranceTransitoireValue]'}
                            value={OPTIONS.SELLING_NOW}
                            label={'Je suis en train de le vendre'}
                            onClick={() => handleOptionClick(OPTIONS.SELLING_NOW)}
                        />
                    </div>
                )}
            </div>

            <button
                className={`btn btn-primary btn-arrow mt-4 ${
                    isButtonDisabled() && 'disabled'
                }`}
                onClick={handleContinue}
            >
                Continuez
            </button>
        </Question>
    );
};